import { useEmbedContentSubscriptionConversation } from "modules/eventEmbedContent/hooks";
import { selectDisplayedContentConversationMode } from "modules/eventEmbedContent/redux";
import { useSelector } from "react-redux";
import { EmbedContentDisplay } from "../EmbedContentDisplay";

interface Props {
  eventId: string;
}

const EmbedContentSubscriber = ({ eventId }: Props) => {
  const { loading, error } = useEmbedContentSubscriptionConversation(eventId);
  const displayedContent = useSelector(selectDisplayedContentConversationMode);

  if (loading || !displayedContent || error) {
    return null;
  }

  return (
    <EmbedContentDisplay key={displayedContent.id} content={displayedContent} />
  );
};

export default EmbedContentSubscriber;
